"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldUse24Hour = exports.isRTL = void 0;
var _localeFallback = require("../localeFallback");
var _localesWith12Hour = require("./localesWith12Hour");
var _rtl = require("./rtl");
var shouldUse24Hour = exports.shouldUse24Hour = function shouldUse24Hour(locale) {
  // consider only first two parts of locale
  var actualLocale = (0, _localeFallback.resolveLocale)(locale).split('-').slice(0, 2).join('-');
  return !_localesWith12Hour.localesWith12Hour.has(actualLocale);
};
var isRTL = exports.isRTL = function isRTL(lang) {
  return _rtl.rtl.has((0, _localeFallback.resolveLocale)(lang));
};
//# sourceMappingURL=misc.js.map